import { TechAdminModule } from './tech-admin/tech-admin.module';
import { UsersStore } from './users/users-service/users.store';
import { ErrorPageModule } from './error-page/error-page.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule, Title } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { Angulartics2Module } from 'angulartics2';

// IDLE SESSION
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'ngx-moment';

// COOKIE SERVICE
import { CookieService } from 'ngx-cookie-service';

import { CoreModule } from '@core';
import { PrintStore, PrintApi, SharedModule } from '@shared';
import { AuthModule } from '@app/login';
import { HomeModule } from './home/home.module';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { PasswordModule } from './password/password.module';
import { CustomBreakPointsProvider } from './@core/custom-breakpoints';
import { RequestsModule } from './requests/requests.module';
import { RequestsSharedModule } from './requests/@shared';
import { TrainingSharedModule } from './training/@shared';
import { RequestsSaveSendStore } from './requests/requests-save-send-service/requests-save-send.store';
import { RequestsSaveSendApi } from './requests/requests-save-send-service/requests-save-send-api.service';
import { RequestsGetDataStore } from './requests/requests-get-data-service/requests-get-data.store';
import { RequestsGetDataApi } from './requests/requests-get-data-service/requests-get-data-api.service';
import { CombosStore } from './requests/combos-service/combos.store';
import { CombosApi } from './requests/combos-service/combos-api.service';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { PanelStore } from './requests/panel/panel.store';
import { LoaderGenericService } from './@shared/loader-generic/loader-generic.service';
import { HelpModule } from './help/help.module';
import { IneSignatureStore } from './requests/ine-signature/services/ine-signature.store';
import { AdminStore } from './users/admin-service/admin-service.store';
import { ControlPanelStore } from './control-panel/control-panel-service/control-panel.store';
import { UserProfilesStore } from './user-profiles/user-profiles-service/user-profiles-service.store';
import { RevolvingStore } from './revolving/services/revolving.store';
import { RevolvingApi } from './revolving/services/revolving-api.service';
import { LogaltySignatureAsyncModule } from './logalty-signature-async/logalty-signature-async.module';
import { LogaltyCallBackModule } from './logalty-call-back/logalty-call-back.module';
import { UsersApiService } from './users/users-service/users-api.service';
import { TariffsStore } from './tariffs/services/tariffs.store';
import { TariffsApi } from './tariffs/services/tariffs.service';
import { DigitalSignatureServiceStore } from './requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { ReleasesModule } from './releases/releases.module';
import { ActivityStore } from './activity/activity-services/activity.store';
import { PingModule } from './ping/ping.module';
import { GeocodeStore } from './requests/geocode-service/geocode.store';
import { GeocodeApi } from './requests/geocode-service/geocode-api.service';
import { ThridPartySignatureModule } from './third-party-signature/third-party-signature.module';
import { LandingVideoselfingModule } from './landing-videoselfing/landing-videoselfing.module';
import { LandingFinishVideoselfingModule } from './landing-finish-videoselfing/landing-finish-videoselfing.module';
import { VideoselfingConsentDialogModule } from './videoselfing-consent/videoselfing-consent.module';
import { LogaltyCallBackMerchantModule } from './logalty-call-back-merchant/logalty-call-merchant-back.module';
import { LogaltySignatureAsyncMerchantModule } from './logalty-signature-async-merchant/logalty-signature-async-merchant.module';
import { ThirdPartySamlModule } from './third-party-saml/third-party-saml.module';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    MaterialModule,
    CoreModule,
    SharedModule,
    RequestsSharedModule,
    TrainingSharedModule,
    ShellModule,
    HomeModule,
    RequestsModule,
    HelpModule,
    ThirdPartySamlModule,
    ReleasesModule,
    AuthModule,
    LogaltySignatureAsyncModule,
    ThridPartySignatureModule,
    LogaltySignatureAsyncMerchantModule,
    LogaltyCallBackModule,
    LogaltyCallBackMerchantModule,
    PingModule,
    PasswordModule,
    Angulartics2Module.forRoot(),
    LandingVideoselfingModule,
    LandingFinishVideoselfingModule,
    VideoselfingConsentDialogModule,
    AppRoutingModule,
    MatIconModule, // must be imported as the last module as it contains the fallback route
    MatButtonModule,
    NgIdleKeepaliveModule.forRoot(),
    MomentModule,
    ErrorPageModule,
    TechAdminModule,
  ],
  declarations: [AppComponent],
  providers: [
    Title,
    CustomBreakPointsProvider,
    CookieService,
    RequestsSaveSendStore,
    RequestsSaveSendApi,
    RequestsGetDataStore,
    RequestsGetDataApi,
    PanelStore,
    CombosStore,
    GeocodeStore,
    GeocodeApi,
    CombosApi,
    PrintStore,
    PrintApi,
    AdminStore,
    RevolvingStore,
    RevolvingApi,
    ControlPanelStore,
    UserProfilesStore,
    LoaderGenericService,
    IneSignatureStore,
    UsersStore,
    UsersApiService,
    TariffsStore,
    TariffsApi,
    DigitalSignatureServiceStore,
    ActivityStore,
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false, showError: true } },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
